// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__GMqL+","borderless":"Header_borderless__DDACO"};